import { Select, TextInput } from '@mantine/core';
import Header from 'components/Header';
import React, { useState } from 'react';

import { ReactComponent as SearchIcon } from 'assets/icons/searchIcon.svg';
import { ReactComponent as FilterIcon } from 'assets/icons/filterIcon.svg';
import { ReactComponent as DownArrow } from 'assets/icons/downArrow.svg';
import ActiveFolder from './components/activeFolders/activeFolder';
import PrimaryButton from 'components/primaryButton';
import AddNewFolderModal from './components/activeFolders/addnewfolderModal';
import { Route, Routes, useLocation } from 'react-router-dom';
import NoPageFound from 'pages/common/pageNotFound';
import SubFolders from './components/activeFolders/subFolders';

import useGetFolders from './hooks/useGetFolders';

function RepositoryTabs() {
  const [newFolderModal, setNewFolderModal] = useState(false);
  const [searchFilter, setSearchFilter] = useState(null);
  const [yearFilter, setYearFilter] = useState(new Date().getFullYear());
  const [monthFilter, setMonthFilter] = useState(null);

  const foldersData = useGetFolders();
  //calculating Years for filter
  let minYear = foldersData?.data?.years[1];
  let maxYear = foldersData?.data?.years[0];
  const validYears = [];
  if (minYear === maxYear) {
    validYears.push({ value: minYear, label: minYear });
  } else {
    for (let i = minYear; i <= maxYear; i++) {
      validYears.push({ value: minYear, label: minYear });
      minYear++;
    }
  }
  //calculating months for filter
  let maxMonth = foldersData?.data?.max_month;
  let monthNames = [];
  const months = [
    { value: null, label: 'All' },
    { value: '1', label: 'January' },
    { value: '2', label: 'February' },
    { value: '3', label: 'March' },
    { value: '4', label: 'April' },
    { value: '5', label: 'May' },
    { value: '6', label: 'June' },
    { value: '7', label: 'July' },
    { value: '8', label: 'August' },
    { value: '9', label: 'September' },
    { value: '10', label: 'October' },
    { value: '11', label: 'November' },
    { value: '12', label: 'December' },
  ];
  if (yearFilter) {
    if (yearFilter === maxYear) {
      monthNames.push({ value: null, label: 'All' });
      for (let i = 1; i <= maxMonth; i++) {
        monthNames.push(months[i]);
      }
    } else {
      monthNames = months;
    }
  }

  const location = useLocation();

  return (
    <>
      <div className='px-5 pb-9'>
        <div className='flex justify-between items-center mt-6'>
          <p className='text-xl text-A8A8A8'>
            Repository &#60;{' '}
            <span className='text-gray font-semibold'> My files</span>
          </p>
          <Header />
        </div>

        <div className={location?.state?.path === undefined ? null : 'hidden'}>
          {foldersData?.data?.data?.length === 0 ? null : (
            <div className='flex justify-end mt-6'>
              <div className='flex items-center space-x-4'>
                <TextInput
                  icon={<SearchIcon />}
                  placeholder='Search'
                  value={searchFilter}
                  onChange={(e) => setSearchFilter(e.target.value)}
                  classNames={{
                    wrapper: 'border-primary border-b',
                    input: 'w-36 bg-light-bg border-none',  
                  }}
                />
                <Select
                  placeholder='Month'
                  icon={<FilterIcon />}
                  value={monthFilter}
                  onChange={setMonthFilter}
                  styles={{ rightSection: { pointerEvents: 'none' } }}
                  rightSection={<DownArrow />}
                  data={monthNames}
                  classNames={{
                    wrapper: 'border-primary border-b',
                    input: 'w-40 bg-light-bg border-none',
                  }}
                />
                <Select
                  placeholder='Year'
                  creatable
                  icon={<FilterIcon />}
                  rightSection={<DownArrow />}
                  // inputFormat='MM/YYYY'
                  // labelFormat='MM/YYYY'
                  data={validYears}
                  clearable
                  value={yearFilter}
                  onChange={setYearFilter}
                  classNames={{
                    wrapper: 'border-primary border-b',
                    input: 'w-36 bg-light-bg border-none',
                  }}
                  styles={{
                    rightSection: { pointerEvents: 'none' },
                    monthPickerControlActive: { color: 'red' },
                    yearPickerControlActive: {
                      color: 'red',
                      backgroundcolor: '#ffffff',
                    },
                  }}
                />

                <button
                  onClick={() => {
                    setNewFolderModal(true);
                  }}
                  className={
                    location?.state?.path === undefined ? null : 'hidden'
                  }
                >
                  <PrimaryButton>+ New Folder</PrimaryButton>
                </button>
              </div>
            </div>
          )}
        </div>
        <div className='mt-9'>
          <Routes>
            <Route
              path=''
              element={
                <ActiveFolder
                  searchFilter={searchFilter}
                  yearFilter={yearFilter}
                  monthFilter={monthFilter}
                />
              }
            />
            <Route path='/:id' element={<SubFolders />} />

            {/* empty page when route not found */}
            <Route path='*' element={<NoPageFound />} />
          </Routes>
        </div>
      </div>
      <AddNewFolderModal
        newFolderModal={newFolderModal}
        setNewFolderModal={setNewFolderModal}
      />
    </>
  );
}

export default RepositoryTabs;
